module.exports = __webpack_public_path__ + "f5a3336536519a0baba6bffbd0af4e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/Slider/images/image6.png
// module id = R5C2
// module chunks = 0